import { WORKSPACE_PADDING, WORKSPACE_PADDING_MOBILE } from '@components/v2/constants';
import { makeStyles } from 'tss-react/mui';

interface UseShowroomStorefrontStylesParams {
  hasTopSpacing?: boolean;
  hasWorkspaceGutter?: boolean;
}

export const useShowroomStorefrontStyles = makeStyles<UseShowroomStorefrontStylesParams>()(
  (theme, { hasTopSpacing = true, hasWorkspaceGutter = true }) => ({
    floatActions: {
      position: 'sticky',
      bottom: theme.spacing(WORKSPACE_PADDING),
      display: 'flex',
      justifyContent: 'flex-end',
      zIndex: theme.zIndex.fab,
      pointerEvents: 'none',
      [theme.breakpoints.down('sm')]: {
        bottom: theme.spacing(WORKSPACE_PADDING_MOBILE),
      },
      '& > *': {
        pointerEvents: 'auto',
      },
    },

    root: {
      marginTop: hasTopSpacing ? theme.spacing(8) : 0,
      paddingInline: hasWorkspaceGutter ? 0 : theme.spacing(WORKSPACE_PADDING),
      [theme.breakpoints.down('sm')]: {
        marginTop: hasTopSpacing ? theme.spacing(7) : 0,
        paddingInline: hasWorkspaceGutter ? 0 : theme.spacing(WORKSPACE_PADDING_MOBILE),
      },
    },

    bannerFullBleed: {
      marginInline: theme.spacing(-WORKSPACE_PADDING),
      [theme.breakpoints.down('sm')]: {
        marginInline: theme.spacing(-WORKSPACE_PADDING_MOBILE),
      },
    },

    sendMessage: {
      height: '100%',
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'white',
      },
    },

    connectionButton: {
      [theme.breakpoints.up('lg')]: {
        '& .MuiButton-sizeLarge': {
          padding: '12px 24px',
          fontSize: '18px',
          width: '160px',
        },
      },
    },
  }),
);
